export function pxToLineHeight(fontPx: number, lineHeightPx: number) {
  return lineHeightPx / fontPx;
}
